import React from 'react';
import { Container } from 'react-bootstrap';

import Stepper from '../../../components/Stepper';
import Header from '../../../components/Header';
import Simulator from './components/Simulator';

const SimulatorContainer = () => {
  window.top.postMessage(
    { scrollToTop: true },
    process.env.REACT_APP_PARENT_DOMAIN
  );

  return (
    <React.Fragment>
      <Header />
      <Container fluid>
        <Stepper />
        <Simulator />
   
      </Container>
    </React.Fragment>
  );
};

export default SimulatorContainer;
